import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const list = createReducer(
  {},
  {
    [ActionTypes.FETCH_LOCATION_SUCCESS]: (state, { payload }) => payload
  }
);

const setStatusForId = (state, { type, payload }) =>
  Object.assign({}, state, { [payload.id]: type });

const status = createReducer(
  {},
  {
    [ActionTypes.FETCH_LOCATION_SUCCESS]: setStatusForId,
    [ActionTypes.FETCH_LOCATION_ERROR]: setStatusForId
  }
);

export default combineReducers({
  list,
  status
});
